module.exports = function() {
  return new Worker(__webpack_public_path__ + "8e906d278d8dc50d268c.worker.js");
};